import productListItem from "../../vueComponents/listItem";


export default {
    _app : null,
    init() {
 
        var favoritesLocalStorageObject = JSON.parse(localStorage.getItem('favorites'));

        if (favoritesLocalStorageObject && favoritesLocalStorageObject.length > 0 && document.getElementById("header__favorites--icon")) {
            document.getElementById("header__favorites--icon").classList.add("header__favorites--icon-active");
        }

        this._app = document.querySelector('[data-vue-favorites]');
        if (!this._app) {
            return;
        }
        
        new Vue({
            el        : this._app,
            delimiters: ['[[', ']]'],
            data      : {
            loading               : false,
            display               : '',
            search                : '',
            bounds                : null,
            articles              : [],
            products              : [],
            mapData               : [],
            infoWindow            : [],
            activeInfoWindow      : null,
            pageIndex             : 0,
            productsPerPage       : 180,
            activities            : {},
            attractions           : {},
            map                   : null,
            amounts               : {},
            selectedCategories    : [],
            selectedMunicipalities: [],
            selectedDestinations  : [],
            selectedSeasons       : [],
            selectedActivities    : [],
            selectedAttractions   : [],
            categories            : {
                1  : 'overnatting',
                2  : 'servering',
                4  : 'tjenester',
                36 : 'aktiviteter',
                69 : 'attraksjoner',
                99 : 'transport',
                110: 'sted',
                203: 'reisepakke',
                405: 'generelle',
            },
            municipalities        : [
                'Aukra',
                'Aure',
                'Averøy',
                'Fjord',
                'Giske',
                'Gjemnes',
                'Hareid',
                'Heim',
                'Herøy',
                'Hustadvika',
                'Kristiansund',
                'Lesja',
                'Molde',
                'Narvik',
                'Oslo',
                'Rauma',
                'Rindal',
                'Sande',
                'Smøla',
                'Stranda',
                'Sula',
                'Sunndal',
                'Surnadal',
                'Sykkylven',
                'Tingvoll',
                'Ulstein',
                'Vanylven',
                'Vestnes',
                'Volda',
                'Ørsta',
                'Ålesund'
            ],
            destinations          : {
                44: 'Geirangerfjord',
                45: 'Visit Nordvest',
                46: 'Ålesund & Sunnmøre',
                887: 'Nordmøre',
                888: 'Romsdal',
                2203: 'Sunnmøre'
            },
            seasons               : {
                40: 'Vår',
                41: 'Sommer',
                42: 'Høst',
                43: 'Vinter'
            },
            activities            : {
                26: 'Sightseeing og rundturer',
                27: 'Vandring og fjellturer',
                28: 'Sport of friluftsliv',
                29: 'Ski og vinter',
                30: 'Barn og familie',
                31: 'Helse og velvære',
                32: 'Jakt og fiske',
            },
            attractions           : {
                47: 'Museum og gallerier',
                48: 'Historie og kulturarv',
                49: 'Naturattraksjoner',
                50: 'Turistveger og utkikkspunkt',
                51: 'Opplevelsessenter',
                2608: 'Restauranter og matopplevelser',
                2619: 'Underholdning, festivaler og musikkopplevelser',
                2700: 'Natur&shy;attraksjoner',
                2774: 'Opplevelses&shy;senter',
            },
                
            },
            created() {
                this.handleUserPastedFavoritesURL();
                this.getProducts();
                this.getArticles();

                setTimeout(() => {
                    if (this.products.length > 0) {
                        this.generateMap();
                        this.addMarkers();
                        this.displayMarkers();
                        this.setupSharingUrl();
                    }
                }, 2000);
            },
            methods: {
                handleUserPastedFavoritesURL: function () {

                    var favoritesLocalStorageObject = JSON.parse(localStorage.getItem('favorites'));
                    var newFavoritesArray = new Array;
                    var url = window.location.href;
                    
                    if (url && url.indexOf("?id") > -1) {
                        var idx = url.indexOf("?");
                        var idx2 = url.indexOf("&");
                        var stringAllIDs = idx != -1 ? url.substring(idx+1) : "";
                        var arrayAllIDs = stringAllIDs.split('&');
                        var myString = "";
                        var currentID;

                        if (favoritesLocalStorageObject && favoritesLocalStorageObject.length > 0) {
                            // URL is pasted and there are items in already in localstorage
                            for (let i = 0; i < arrayAllIDs.length; i++) {
                                myString = arrayAllIDs[i].replace('id=','');
                                currentID = parseInt( myString );
                                if ( !favoritesLocalStorageObject.includes(currentID) ) {
                                    favoritesLocalStorageObject.push(currentID);
                                }
                            }
                            localStorage.setItem('favorites', JSON.stringify(favoritesLocalStorageObject) );
                        }
                        else {
                            // URL is pasted but there are no items currently in localstorage
                            for (let i = 0; i < arrayAllIDs.length; i++) {
                                myString = arrayAllIDs[i].replace('id=','');
                                currentID = parseInt( myString );
                                newFavoritesArray.push(currentID);
                            }
                            localStorage.setItem('favorites', JSON.stringify(newFavoritesArray) );
                        }

                    }

                },
                hideFlashNotice: function (event) {
                    var infoLinkCopied = document.getElementById("favorites__flashnotice");
                    infoLinkCopied.classList.remove("favorites__flashnotice--active");
                },
                copyUrlToClipboard: function (event) {
                    var element = document.getElementById("favorites__url");
                    var infoLinkCopied = document.getElementById("favorites__flashnotice");
                    var range, selection, worked;
                    
                    element.style.display = "block";
                    
                    if (document.body.createTextRange) {
                        range = document.body.createTextRange();
                        range.moveToElementText(element);
                        range.select();
                    } else if (window.getSelection) {
                        selection = window.getSelection();        
                        range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                    
                    try {
                        document.execCommand('copy');
                        infoLinkCopied.classList.add("favorites__flashnotice--active");
                    }
                    catch (err) {
                        //alert('unable to copy text');
                    }
                    element.style.display = "none";

                    event.preventDefault();
                },
                toggleFavorites: function (event) {
                    var currentID = parseInt(event.target.id);
                    var favoritesLocalStorageObject = JSON.parse(localStorage.getItem('favorites'));
                    var articlesArray = this.articles;
                    var productsArray = this.products;
                    var header_favorites_icon = document.getElementById("header__favorites--icon");

                    var infoLinkCopied = document.getElementById("favorites__flashnotice");
                    if(infoLinkCopied){
                        infoLinkCopied.classList.remove("favorites__flashnotice--active");
                    }
                    

                    if ( favoritesLocalStorageObject && favoritesLocalStorageObject.includes(currentID) ) {
                        for (var i = 0; i < favoritesLocalStorageObject.length; i++) {
                            if (favoritesLocalStorageObject[i]==currentID) favoritesLocalStorageObject.splice(i, 1);
                        }
                    }
                    localStorage.setItem('favorites', JSON.stringify(favoritesLocalStorageObject) );
                    if ( favoritesLocalStorageObject.length == 0 && header_favorites_icon && header_favorites_icon.classList.contains("header__favorites--icon-active") ) {
                        document.getElementById("header__favorites--icon").classList.remove("header__favorites--icon-active");
                    }

                    for (var i = 0; i < this.products.length; i++) {
                        if ( currentID == this.products[i].id ) {
                            productsArray.splice(i, 1);
                        }
                    }
                    this.products = productsArray;

                    for (var i = 0; i < this.articles.length; i++) {
                        if ( currentID == this.articles[i].id ) {
                            articlesArray.splice(i, 1);
                        }
                    }
                    this.articles = articlesArray;

                    this.generateMap();
                    this.addMarkers();
                    this.displayMarkers();

                    this.setupSharingUrl();

                    event.preventDefault();
                },
                getProducts() {
                    var boolIDFound = false;
                    if (this.products.length) {
                        return true;
                    }
                    this.loading = true;
                    const xhr = new XMLHttpRequest();
        
                    xhr.onload = () => {
                        if (xhr.responseText) {
                            const result  = JSON.parse(xhr.responseText);
                            var productsArray = new Array;
                            var favoritesObjectLocalStorage = JSON.parse(localStorage.getItem('favorites'));
                            if ( favoritesObjectLocalStorage ) {
                                for (var pIndex = 0; pIndex < result.length; pIndex++) {
                                    
                                    boolIDFound = false;
                                    for (var lsIndex = 0; lsIndex < favoritesObjectLocalStorage.length; lsIndex++) {
                                        if ( favoritesObjectLocalStorage[lsIndex] == result[pIndex].id ) {
                                            boolIDFound = true;
                                        }
                                    }
                                    if (boolIDFound) {
                                        productsArray.push(result[pIndex]);
                                    }
                                }
                            }
                            this.products = productsArray;
                            this.loading  = false;
                        } else {
                            this.loading = false;

                            console.error('ERROR: Could not GET products');
                        }
                    }

                    xhr.open('get', '/actions/mm/poi/index');
                    xhr.send();
                },
                getArticles() {
                    var boolIDFound = false;
                    if (this.articles.length) {
                        return true;
                    }
                    this.loading = true;
                    const xhr = new XMLHttpRequest();
        
                    xhr.onload = () => {
                        if (xhr.responseText) {
                            const result  = JSON.parse(xhr.responseText);
                            var articlesArray = new Array;
                            var favoritesObjectLocalStorage = JSON.parse(localStorage.getItem('favorites'));
                            if ( favoritesObjectLocalStorage ) {
                                for (var aIndex = 0; aIndex < result.length; aIndex++) {
                                    boolIDFound = false;
                                    for (var lsIndex = 0; lsIndex < favoritesObjectLocalStorage.length; lsIndex++) {
                                        if ( favoritesObjectLocalStorage[lsIndex] == result[aIndex].id ) {
                                            boolIDFound = true;
                                        }
                                    }
                                    if (boolIDFound) {
                                        articlesArray.push(result[aIndex]);
                                    }
                                }
                            }
                            this.articles = articlesArray;
                            this.loading  = false;
                        } else {
                            this.loading = false;

                            console.error('ERROR: Could not GET articles');
                        }
                    }

                    xhr.open('get', '/actions/visitmr/entries/articles');
                    xhr.send();
                },
                setupSharingUrl() {
                    
                    var favoritesIdArray = new Array;
                    for (var pIndex = 0; pIndex < this.products.length; pIndex++) {
                        favoritesIdArray.push(this.products[pIndex].id);
                    }
                    for (var aIndex = 0; aIndex < this.articles.length; aIndex++) {
                        favoritesIdArray.push(this.articles[aIndex].id);
                    }
                    var pairs = favoritesIdArray.map(function (value) { return "id=" + encodeURIComponent(value) });
                    var query_string = pairs.join("&");
                    query_string = window.location.href + "?" + query_string;
                    document.getElementById("favorites__url").innerHTML = query_string;

                    //document.location.search = query_string;
                },
                // Google-map //
                generateMap() {

                    const options = {
                        zoom             : 9,
                        mapTypeControl   : false,
                        streetViewControl: false,
                        fullscreenControl: false,
                        scrollwheel      : false
                    }
                    this.map    = new google.maps.Map(document.getElementById('map'), options);
                    this.bounds = new google.maps.LatLngBounds();
                    // this.$refs.map
                },
                addMarkers() {
                    for (const product of this.products) {
                        if (!product.lat || !product.lng) {
                            continue;
                        }
                        
                        const markerImgUrl = `/resources/img/marker_${this.categories[product.category]}.svg`;
                        const markerSize   = new google.maps.Size(18.4, 32.9);
                        const markerIcon   = new google.maps.MarkerImage(
                            markerImgUrl,
                            markerSize
                        );
            
                        const marker       = new google.maps.Marker({
                            position: new google.maps.LatLng(product.lat, product.lng),
                            map     : this.map,
                            icon    : markerIcon
                        });
            
                        this.bounds.extend(marker.position);
            
                        const infoWindow = new google.maps.InfoWindow({
                            content: this.getInfoWindowContent(product)
                        });
            
                        this.mapData.push({
                            marker      : marker, 
                            infoWindow  : infoWindow, 
                            categories  : product.categories, 
                            municipality: product.municipality, 
                            pictureUrl  : product.img
                        });
                    }
            
                    for (const item of this.mapData) {
                        item.marker.addListener('click', () => {
                            if (this.activeInfoWindow) {
                                this.activeInfoWindow.close();
                            }
                            const imgString = '<img class="map-info__image"';
                            if (!item.infoWindow.content.includes(imgString + ' src=')) {
                                const splitContent = item.infoWindow.content.split(imgString);
                                if (splitContent.length === 2) {
                                    const content = splitContent[0] + `${imgString} src="${item.pictureUrl}"` + splitContent[1];
                                    item.infoWindow.setContent(content);
                                }
                            }
                            item.infoWindow.open(this.map, item.marker);
                            this.activeInfoWindow = item.infoWindow;
                        });
                    }
                    
                    this.map.fitBounds(this.bounds);
                },
                displayMarkers() {
                    for (const product of this.mapData) {
                        const categoryMatch     = !this.selectedCategories.length || 
                                                   this.selectedCategories.some(category => product.categories.indexOf(parseInt(category)) >= 0);
                        const municipalityMatch = !this.selectedMunicipalities.length || 
                                                   this.selectedMunicipalities.includes(product.municipality);
                        const showMarker        = (municipalityMatch && categoryMatch) || 
                                                  (!this.selectedCategories.length && !this.selectedMunicipalities.length)
                        product.marker.setVisible(showMarker)
                    }
                },
                getInfoWindowContent(product) {
                    const iconStart = '<img class="product__info-icon" src="/resources/img/icon--';
            
                    let content = `
                        <div class="map-info" id="content">
                            ${product.img ? '<img class="map-info__image">' : ''}
                            <div class="map-info__content">
                                <div class="map-info__title">${product.title}</div>
                                <div class="map-info__links">
                    `;
                    if (product.phone) {
                        content += `
                            <a class="map-info__link" href="tel:${product.phone}">
                                ${iconStart}01.png" alt="">${product.phone}
                            </a>
                        `;
                    }
                    if (product.email) {
                        content += `
                            <a class="map-info__link" href="mailto:${product.email}">
                                ${iconStart}02.png" alt="">${product.email}
                            </a>
                        `;
                    }
                    if (product.web) {
                        if (!product.web.includes('http')) {
                            product.web = 'http://' + product.web;
                        }
                        content += `
                            <a class="map-info__link" href="${product.web}">
                                ${iconStart}03.png" alt="">Nettside
                            </a>
                        `;
                    }
                    content += `
                                </div>
                                <a class="map-info__redirect" href="${product.url}">
                                    Les mer${product.booking ? ' og bestill' : ''}
                                </a>
                            </div>
                        </div>
                    `;
            
                    return content;
                },

            },
            computed: {

            },
            watch: {

            }
        });
    }
}
